import React, { memo, useLayoutEffect, useRef } from 'react';

const getItemMeasurementKey = (item, index) =>
    item?.Id ?? item?.ID ?? item?.id ?? item?.date ?? item?.ActivityDate ?? item?.key ?? index;

const RowComponent = memo(
    ({ index, style, ariaAttributes, data, setHeight, renderRow, heightCacheKey }) => {
        const rowRef = useRef();
        const measuredRowRef = useRef();
        const item = data?.[index];
        const itemKey = getItemMeasurementKey(item, index);

        useLayoutEffect(() => {
            const contentEl = rowRef.current?.firstElementChild;
            if (!contentEl) return;

            const measure = () => {
                const height = contentEl.getBoundingClientRect().height;
                const measuredRow = measuredRowRef.current;
                const hasMeasuredRow =
                    measuredRow?.index === index &&
                    measuredRow?.itemKey === itemKey &&
                    measuredRow?.heightCacheKey === heightCacheKey &&
                    measuredRow?.height === height;

                if (height > 0 && !hasMeasuredRow) {
                    measuredRowRef.current = { index, itemKey, heightCacheKey, height };
                    setHeight(index, height);
                }
            };

            measure();

            if (typeof ResizeObserver === 'undefined') return;
            const observer = new ResizeObserver(measure);
            observer.observe(contentEl);

            return () => observer.disconnect();
        }, [setHeight, index, itemKey, heightCacheKey]);

        if (!item) return null;

        return (
            <div ref={rowRef} style={style} {...ariaAttributes}>
                {renderRow({ index, data: item })}
            </div>
        );
    },
);

export default RowComponent;
